import React, { useState } from 'react'
import Datepicker from 'gatsby-theme-kn/src/components/technical/Datepicker'
import { useTranslation } from 'react-i18next'
import {
  apiURL,
  formatDate,
  dateFormatter,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalDebitorSearch from 'gatsby-theme-kn/src/components/modules/ModalDebitorSearch'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceDeliveryStatus = () => {
  const { t } = useTranslation()

  const [InputData, setInputData] = useState({
    customer_number: '',
    work_order_number_from: '',
    work_order_number_to: '',
    delivery_date_from: '',
    delivery_date_to: '',
    route: '',
  })
  const [Fdata, setFdata] = useState(false)

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  const FormSubmit = (e) => {
    e.preventDefault()

    const d = new FormData()
    d.append('delivery_status[customer_number]', InputData.customer_number)
    d.append(
      'delivery_status[work_order_number_from]',
      InputData.work_order_number_from
    )
    d.append(
      'delivery_status[work_order_number_to]',
      InputData.work_order_number_to
    )
    d.append(
      'delivery_status[delivery_date_from]',
      dateFormatter(InputData.delivery_date_from)
    )
    d.append(
      'delivery_status[delivery_date_to]',
      dateFormatter(InputData.delivery_date_to)
    )
    d.append('delivery_status[route]', InputData.route)

    setFdata(d)
    setPartnerPortalUrl(
      apiURL(
        'delivery_status?customer_number=' +
          InputData.customer_number +
          '&t=' +
          new Date().getMilliseconds()
      )
    )

    return true
  }

  // Modal 2 (Debitoren-Auswahl)
  const setDebitor = function (debitor) {
    setInputData({
      ...InputData,
      customer_number: debitor,
    })
    setModalState2(false)
  }
  const [modalState2, setModalState2] = useState(false)
  const closeModal2 = () => {
    setModalState2(false)
  }

  const routePath = function (route, customer_number) {
    return '?route=' + route + '&customer_number=' + customer_number
  }

  return (
    <>
      <ModalModule isOpen={modalState2} closeModal={closeModal2}>
        <ModalDebitorSearch setDebitor={setDebitor} />
      </ModalModule>
      <div className="spa-block-full" data-spa-type="delivery_status">
        <form className="needs-validation">
          <div className="row mb-1">
            <div className="mb-1 required col-md-6">
              <label htmlFor="customer_number">
                {t('generic.spa.customer_number')}
              </label>
              <input
                type="text"
                className="form-control"
                name="customer_number"
                required
                autoFocus
                value={InputData.customer_number}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    customer_number: e.target.value,
                  })
                }
              />
              <div className="invalid-feedback">
                {t('generic.spa.customer_number_hint')}
              </div>

              <div className="form-label-group">
                <small className="position-absolute">
                  {t('generic.spa.customer_number_unknown') + ' '}
                  <a href="#" onClick={() => setModalState2(true)}>
                    {t('generic.spa.search_debitor')}
                  </a>
                </small>
              </div>
            </div>

            <div className="mb-1 col-md-3">
              <label htmlFor="work_order_number_from">
                {t('generic.spa.work_order_number_from')}
              </label>
              <input
                type="text"
                className="form-control"
                name="work_order_number_from"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    work_order_number_from: e.target.value,
                  })
                }
              />
            </div>

            <div className="mb-1 col-md-3">
              <label htmlFor="work_order_number_to">
                {t('generic.spa.work_order_number_to')}
              </label>
              <input
                type="text"
                className="form-control"
                name="work_order_number_to"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    work_order_number_to: e.target.value,
                  })
                }
              />
            </div>
          </div>

          <div className="row mt-2">
            <div className="mb-1 col-md-3">
              <label htmlFor="date_from">{t('generic.spa.date_from')}</label>
              <Datepicker
                selected={InputData.delivery_date_from}
                name="delivery_date_from"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    delivery_date_from: date,
                  })
                }
              />
            </div>

            <div className="mb-1 col-md-3">
              <label htmlFor="date_to">{t('generic.spa.date_to')}</label>
              <Datepicker
                selected={InputData.delivery_date_to}
                name="delivery_date_to"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    delivery_date_to: date,
                  })
                }
              />
            </div>

            <div className="mb-1 col-md-3">
              <label htmlFor="route">{t('generic.spa.route')}</label>
              <input
                type="text"
                className="form-control"
                name="route"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    route: e.target.value,
                  })
                }
              />
            </div>

            <div className="mb-1 col-md-3 position-relative">
              <div style={{ bottom: '.15em', position: 'absolute' }}>
                <button
                  className="btn btn-primary btn-sm"
                  type="submit"
                  onClick={(e) => FormSubmit(e)}
                >
                  {t('generic.spa.send')}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>

      {loading && <LoadingSpinner />}

      {data && (
        <div className="spa-block-full mt-2">
          <div data-spa-result-for="delivery_status">
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  {t('generic.spa.results.delivery_status.columns').map(
                    (col, index) => (
                      <th key={index}>{col}</th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {data.daten.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <a href={routePath(row.route, InputData.customer_number)}>
                        {row.route}
                      </a>
                    </td>
                    <td>{formatDate(row.lieferdatum)}</td>
                    <td>{row.kfz}</td>
                    <td>{row.telefon}</td>
                    <td>{row.fahrer}</td>
                    <td>{row.aenderung}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      {/* <pre>{JSON.stringify(data, null, 2)}</pre> */}
    </>
  )
}

export default SapServiceDeliveryStatus
